import {formatQualificationDateToPqe} from '../shared/services/format-pqe'

export const CandidateProfileDirectiveController = (
  $scope,
  userService,
  CandidateProfileApi,
  PreferencesApi,
  $modal,
  $location,
  usSpinnerService,
  SharedApi,
  socket,
  logger,
  $rootScope,
  api,
  $interval
  // $timeout
) => {
  const updateQualificationDate = input => {
    console.debug('updateQualificationDate', input)
    if ($scope.candidate && $scope.candidate.lawProfile) {
      $scope.candidate.lawProfile.qualificationDate = input
      $scope.candidate.calculatedPqe = formatQualificationDateToPqe(
        $scope.candidate.lawProfile.qualificationDate
      )
      console.debug('calculatedPqe', $scope.candidate.calculatedPqe)
      $scope.$applyAsync()
    } else {
      console.warn('no candidate or lawProfile')
    }
  }

  const getUserFromSession = async () => {
    const user = await userService.getUser()
    $scope.currentCandidate = $scope.profileUser ? $scope.profileUser : user.id
    initializeProfile()
  }

  if ($scope.profileUser === undefined) {
    $scope.currentCandidate = $location.search().user
    initializeProfile()
  } else {
    getUserFromSession()
  }

  socket.on('CONVERSATION_NOTE_CREATED', data => {
    if (data === $scope.candidate.id) getCandidateLastConversation()
  })
  socket.on('CONVERSATION_NOTE_UPDATED', data => {
    if (data === $scope.candidate.id) getCandidateLastConversation()
  })

  // eslint-disable-next-line no-unused-vars
  const updateAgentName = agentId => {
    const found = $scope.assignableAgents.find(agent => agent.id === agentId)

    console.debug('updateAgentName. Found:', found)

    if (found) {
      $scope.candidate.agent = found
    } else {
      console.warn('could not find agent')
    }
  }

  const updateApplicationsCount = async () => {
    try {
      const result = await api.get(
        `applications/candidate/${$scope.candidate.id}/count`
      )
      if (!result) {
        $scope.candidateApplicationsCount = 0
      }

      const {data} = result

      $scope.candidateApplicationsCount = data
    } catch (error) {
      console.error('updateApplicationsCount error:', error)
    }
  }

  $scope.$on('application:created', () => {
    console.warn('application created')
    updateApplicationsCount()
  })

  $interval(updateApplicationsCount, 10000)

  async function getCandidateProfile() {
    const {data} = await CandidateProfileApi.getUserProfile(
      $scope.currentCandidate
    )
    $scope.candidate = data
    $scope.referrerName = await SharedApi.getReferrer($scope.currentCandidate)
  }

  $scope.$on('candidate:update:ready', () => {
    console.debug('candidate:update:ready')
    // Const handleUpdate = async () => {
    //   console.debug('handleUpdate')
    //   await wrap(async () => getCandidateProfile())
    // }

    // handleUpdate().then(() => {
    //   console.debug('candidate:updated done', $scope.candidate)
    //   updateAgentName($scope.candidate.agentId)
    // })
  })

  async function getPreferences() {
    await Promise.all([
      PreferencesApi.getCategoryById(1),
      PreferencesApi.getCategoryById(2),
      PreferencesApi.getCategoryById(3),
      PreferencesApi.getLocations(),
      PreferencesApi.getLanguages(),
      PreferencesApi.getContractTypes(),
      PreferencesApi.getOccupationsByProfession('law'),
      CandidateProfileApi.getUserResumes($scope.currentCandidate),
      SharedApi.getAllSchools(),
      SharedApi.getAllNationalities(),
    ]).then(
      result => {
        $scope.legalPracticeAreas = result[0].data.specialties
        $scope.legalEmployerType = result[1].data.specialties
        $scope.legalJurisdiction = result[2].data.specialties
        $scope.locations = result[3].data
        $scope.languages = result[4].data
        $scope.contractTypes = result[5].data
        $scope.occupations = result[6].data
        $scope.candidate.resumes = result[7].data
        $scope.schoolList = result[8].data
        $scope.nationalitiesList = result[9].data
          .map(nationality => {
            return {
              code: nationality.code,
              name: nationality.demonyms[0],
            }
          })
          .filter(nationality => nationality.name)
        const school = $scope.schoolList.find(
          x => x.id === $scope.candidate.schoolId
        )
        const schoolName = school && school.name ? school.name : 'n/a'
        $scope.schoolName = schoolName
      },
      error => {
        console.error(`Error loading candidate profile: ${error}`)
      }
    )
    const lowerEmail =
      $scope.candidate.user.email &&
      $scope.candidate.user.email.trim().toLowerCase()
    // eslint-disable-next-line no-undef
    const gravatarHash = lowerEmail && SparkMD5.hash(lowerEmail)
    const gravatarUrl = gravatarHash
      ? `https://www.gravatar.com/avatar/${gravatarHash}?s=400&d=retro`
      : `images/defaultPic.jpg`

    if ($scope.user.isAdmin) $scope.candidate.isAdminProfile = true
    if (
      $scope.candidate.user.profilePicture &&
      $scope.candidate.user.profilePicture.contains('https://')
    )
      $scope.candidate.user.logoSrc = $scope.candidate.user.profilePicture
    else if ($scope.candidate.user.profilePicture)
      $scope.candidate.user.logoSrc = `${process.env.PUBLIC_BUCKET_URL}/user/${$scope.candidate.id}/photo/${$scope.candidate.user.profilePicture}`
    else $scope.candidate.user.logoSrc = gravatarUrl
    getCandidateLanguages()
    getCandidateLastConversation()
  }

  const getCandidateLanguages = async () => {
    const {data} = await CandidateProfileApi.getUserProfile(
      $scope.currentCandidate,
      {
        include: ['languages'],
      }
    )
    $scope.candidate.languages = data ? data.languages : []
    $scope.candidate.languages =
      $scope.languages &&
      $scope.languages.map(language => {
        return Object.assign(
          {
            isSelected: Boolean(
              $scope.candidate.languages.find(
                candidateLanguage => candidateLanguage.code === language.code
              )
            ),
          },
          language
        )
      })
  }

  const getCandidateLastConversation = () => {
    CandidateProfileApi.getLastConversation($scope.currentCandidate).then(
      ({data}) => {
        $scope.lastConversationDate = data
        $scope.lastConversationDay = data
          ? Math.floor((new Date() - new Date(data)) / (1000 * 60 * 60 * 24))
          : undefined
        $scope.approvedSince = Math.floor(
          (new Date() - new Date($scope.candidate.approvalAcceptDate)) /
            (1000 * 60 * 60 * 24)
        )
        $scope.$apply()
      },
      () => {
        $scope.lastConversationDate = undefined
        $scope.lastConversationDay = undefined
        $scope.approvedSince = undefined
        $scope.$apply()
      }
    )
  }

  async function initializeProfile() {
    $scope.user = await userService.getUser()
    await getCandidateProfile()
    await getPreferences()
    $scope.candidate.nationality =
      $scope.candidate.nationalities &&
      $scope.candidate.nationalities.length > 0
        ? $scope.candidate.nationalities
            .map(nationality => {
              return {
                code: nationality.code,
                name: nationality.demonyms[0],
              }
            })
            .find(nationality => nationality.name)
        : undefined

    $scope.candidate.candidateEducation =
      $scope.candidate.school && $scope.candidate.school.name
    $scope.candidate.linkedInData = JSON.parse($scope.candidate.linkedinData)

    // Preferences data

    const candidateEmployerTypes =
      $scope.candidate.category &&
      $scope.candidate.category.find(category => category.id === 2).specialties
    $scope.candidate.legalEmployerTypes =
      $scope.legalEmployerType &&
      $scope.legalEmployerType.map(employerType => {
        return Object.assign(
          {
            isSelected: Boolean(
              candidateEmployerTypes.find(
                candidateEmployerType =>
                  candidateEmployerType.id === employerType.id
              )
            ),
          },
          employerType
        )
      })
    $scope.candidate.occupations =
      $scope.occupations &&
      $scope.occupations.map(contractType => {
        return Object.assign(
          {
            isSelected: Boolean(
              $scope.candidate.occupations.find(
                candidateOccupation =>
                  candidateOccupation.id === contractType.id
              )
            ),
          },
          contractType
        )
      })
    $scope.candidate.preferredContractTypes =
      $scope.contractTypes &&
      $scope.contractTypes.map(contractType => {
        return Object.assign(
          {
            isSelected: Boolean(
              $scope.candidate.preferredContractTypes.find(
                candidateContractType =>
                  candidateContractType.id === contractType.id
              )
            ),
          },
          contractType
        )
      })
    $scope.candidate.legalPracticeAreas = $scope.candidate.category.find(
      category => category.id === 1
    ).specialties

    const candidateJurisdictions = $scope.candidate.category.find(
      category => category.id === 3
    ).specialties
    $scope.candidate.legalJurisdictions =
      $scope.legalJurisdiction &&
      $scope.legalJurisdiction.map(jurisdiction => {
        return Object.assign(
          {
            isSelected: Boolean(
              candidateJurisdictions.find(
                candidateJurisdiction =>
                  candidateJurisdiction.id === jurisdiction.id
              )
            ),
          },
          jurisdiction
        )
      })
    updateQualificationDate(
      $scope.candidate &&
        $scope.candidate.lawProfile &&
        $scope.candidate.lawProfile.qualificationDate
    )
    await updateApplicationsCount()
    $scope.$apply()
  }

  $scope.editUserData = {
    firstName: '',
    lastName: '',
  }

  $scope.editName = () => {
    $scope.editUserData.firstName = $scope.candidate.user.firstName
    $scope.editUserData.lastName = $scope.candidate.user.lastName
    $scope.editingName = true
  }

  $scope.changeName = async () => {
    await CandidateProfileApi.updateUserData(
      $scope.candidate.id,
      $scope.editUserData
    )
    $scope.candidate.user.firstName = $scope.editUserData.firstName
    $scope.candidate.user.lastName = $scope.editUserData.lastName
    $scope.$apply()
  }

  $scope.uploadProfilePicture = async file => {
    if ($scope.candidate.approvalStatus === 'Locked' && !$scope.user.isAdmin) {
      logger.notify(
        'error',
        `Unable to upload Profile as Candidate Profile is Locked`
      )
    } else {
      usSpinnerService.spin('spinner-dp')
      let formData = new FormData()
      formData.append('file', file[0])
      const {
        data: profilePicture,
      } = await CandidateProfileApi.uploadProfilePhoto(
        $scope.candidate.id,
        formData
      )
      $scope.candidate.user.profilePicture = profilePicture
      $scope.candidate.user.logoSrc = `${process.env.PUBLIC_BUCKET_URL}/user/${$scope.candidate.id}/photo/${$scope.candidate.user.profilePicture}`
      usSpinnerService.stop('spinner-dp')
      $scope.$apply()
    }
  }

  $scope.deleteProfilePic = async () => {
    await CandidateProfileApi.deleteProfilePhoto($scope.candidate.id)
    $scope.candidate.user.profilePicture = undefined
    $scope.candidate.user.logoSrc = `images/defaultPic.jpg`
    $scope.$apply()
  }

  $scope.openCandidateEditableField = event => {
    const id = event.target.attributes.id.value
    $scope.editableCandidateProfile = {
      id: $scope.candidate.id,
      university: $scope.candidate.candidateEducation,
      employer: $scope.candidate.employer ? $scope.candidate.employer.name : '',
      nationality: $scope.candidate.nationality,
      currentLocation: $scope.candidate.location,
      pqe: $scope.candidate.lawProfile.qualificationDate,
    }
    if (id === 'candidate-profile') {
      $scope.showEditableProfileField = true
      $scope.showCancelProfileField = true
    } else if (id === 'edit-pqe') {
      $scope.showPQECancel = true
      $scope.showPQEField = true
    }
  }

  $scope.isValidUpdateCandidateProfileField = () => {
    if (
      $scope.editableCandidateProfile.university &&
      $scope.editableCandidateProfile.nationality &&
      $scope.editableCandidateProfile.currentLocation
    ) {
      return true
    }

    logger.notify('warning', 'Please complete all fields')
    return false
  }

  $scope.updateCandidateProfileField = async () => {
    usSpinnerService.spin('spinner-candidate')
    let school

    if ($scope.isValidUpdateCandidateProfileField()) {
      const existingSchool = $scope.schoolList.find(
        ({name}) => name === $scope.editableCandidateProfile.university
      )
      school = existingSchool
      if (!existingSchool) {
        const {
          data: newSchool,
          status: statusSchool,
        } = await SharedApi.addSchool({
          name: $scope.editableCandidateProfile.university,
        })
        if (statusSchool === 201) {
          $scope.schoolList.push(newSchool)
          school = newSchool
        }
      }

      let payload = school ? {schoolId: school.id} : {}
      payload = $scope.editableCandidateProfile.currentLocation
        ? Object.assign(payload, {
            location: Number(
              $scope.editableCandidateProfile.currentLocation.id
            ),
          })
        : payload
      payload = $scope.editableCandidateProfile.nationality
        ? Object.assign(payload, {
            candidatePreference: {
              nationalities: [$scope.editableCandidateProfile.nationality.code],
            },
          })
        : payload
      payload = $scope.editableCandidateProfile.pqe
        ? Object.assign(payload, {
            lawProfile: {
              qualificationDate: $scope.editableCandidateProfile.pqe,
            },
          })
        : payload

      await CandidateProfileApi.updateProfileData($scope.candidate.id, payload)
      $scope.showEditableProfileField = false
      $scope.showCancelProfileField = false
      logger.notify('success', `Candidate Profile updated successfully`)
      $scope.candidate.candidateEducation = school && school.name
      $scope.candidate.nationality =
        $scope.editableCandidateProfile.nationality &&
        $scope.editableCandidateProfile.nationality
      $scope.candidate.location =
        $scope.editableCandidateProfile.currentLocation

      $scope.qualificationDate = $scope.editableCandidateProfile.pqe

      $scope.$apply()
    }

    usSpinnerService.stop('spinner-candidate')
  }

  $scope.cancelUpdateProfileField = event => {
    const id = event.target.attributes.id.value
    if (id === 'cancel-candidate-profile') {
      $scope.showEditableProfileField = false
      $scope.showCancelProfileField = false
    } else if (id === 'cancel-pqe') {
      $scope.showPQECancel = false
      $scope.showPQEField = false
    }
  }

  // Recommendations: Start
  $scope.recommendationsCount = {
    regularCustom: '*',
    specConnect: '*',
  }

  $scope.recommendations = {
    showRegularCustom: false,
    showSpecConnect: false,
  }

  $scope.showRecommendations = type => {
    $scope.preferredLocation = true
    $scope.recommendations[type] = true
    $scope.showApplicationsTab = false
    console.debug(`candidateProfile.showRecommendations(${type})`)
    $scope.$broadcast('tab:change', `recommendations/${type}`)
  }
  // Recommendations: End

  $scope.showApplicationsTab = false

  $scope.showApplications = () => {
    $scope.showApplicationsTab = true
  }

  $scope.showPreferenceTab = false

  $scope.showPreferences = () => {
    $scope.showPreferenceTab = true
  }

  // Notes: Start
  $scope.showNotesTab = false
  $scope.showNotes = () => {
    $scope.showNotesTab = true
  }
  // Notes: End

  // Actions: Start
  determineIsLawyersActionAllowedToView()
  function determineIsLawyersActionAllowedToView(_assignedAgent) {
    $scope.isCandidateActionsAllowedToView = true
    // TODO: Add Permissions
    // TODO: Add newUser and no registered user page
    // $scope.isCandidateActionsAllowedToView = Boolean(
    //   accountPermission.isLawyersActionsAllowed($scope.user) ||
    //     assignedAgent === $scope.user.id
    // )
  }

  $scope.openActionsModal = async (userID, event) => {
    event.preventDefault()
    event.stopPropagation()
    // $scope.showActionsSpinner = true
    // $scope.startSpin('spinner-' + userID)
    $scope.selectedCandidate = $scope.candidate
    let modalData
    await Promise.all([
      CandidateProfileApi.getUserBlockedEmployers($scope.candidate.id),
      CandidateProfileApi.getAdminAndCorporateUsers(),
      CandidateProfileApi.getUserSettings($scope.candidate.id),
      CandidateProfileApi.getEmployersList(),
    ]).then(results => {
      const blockedEmployersList =
        results[3].data &&
        results[3].data.map(employer => {
          return Object.assign(
            {
              isSelected: Boolean(
                results[0].data.find(
                  blockedEmployer =>
                    blockedEmployer.employerId === employer.id &&
                    blockedEmployer.block
                )
              ),
            },
            employer
          )
        })

      console.debug('blockedEmployersList', {
        blockedEmployersList,
        result: results[3],
      })

      $scope.assignableAgents = results[1].data

      modalData = {
        candidate: $scope.candidate,
        // BlockedEmployers: _.union(
        //   [
        //     {
        //       userId: $scope.candidate.id,
        //       block: true,
        //       employerId: $scope.candidate.employerId,
        //     },
        //   ],
        //   results[0].data
        // ),
        blockedEmployers: results[0].data,
        assignableAgents: $scope.assignableAgents,
        candidateSettings: results[2].data,
        employersList: blockedEmployersList,
      }
      console.warn('modalData', modalData)
    })

    const modalInstance = $modal.open({
      templateUrl: 'edit-candidate-modal.html',
      controller: 'EditCandidateCtrl',
      controllerAs: 'ctrl',
      resolve: {
        data: function() {
          return modalData
        },
        candidateId: function() {
          return $scope.candidate.id
        },
      },
    })
    modalInstance.result.then(async data => {
      console.debug('CandidateProfile::actions::result', data)
      if (data.updatedApprovalStatus) {
        $scope.candidate.approvalStatus = data.updatedApprovalStatus
        if (data.updatedApprovalStatus === 'Approved')
          $scope.candidate.approvalAcceptDate = new Date()
        // $scope.$apply()
      }

      updateQualificationDate(
        data.updatedQualificationDate
          ? data.updatedQualificationDate
          : data.updatedCandidateProfile.lawProfile.qualificationDate
      )

      if (data.updatedCandidateProfile) {
        $scope.candidate.minSelectivity =
          data.updatedCandidateProfile.minSelectivity
        $scope.candidate.maxSelectivity =
          data.updatedCandidateProfile.maxSelectivity
        console.debug('assignableAgents:', $scope.assignableAgents)
        $scope.candidate.agent = $scope.assignableAgents.find(
          agent => agent.id === data.updatedCandidateProfile.agentId
        )
        console.debug('$scope.candidate.agent:', $scope.candidate.agent)
        $rootScope.$broadcast('candidate:update:ready')
      }
    })
  }

  // Actions: End
}



// WEBPACK FOOTER //
// ./scripts/candidate-profile/candidate-profile.ctrl.js